import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconCloseCircleFillMedium from "@amzn/stencil-react-icons/icons/icon-close-circle-fill-medium";
import { useIntl } from "react-intl";

interface ChatHeaderProps {
  title: string;
  subtitle?: string;
  logo: React.ReactNode;
  color: string;
  altLogo?: React.ReactNode;
  altColor?: string;
  onAltClick?: () => void;
  onClose?: () => void;
}

export const ChatHeader = ({
  title,
  subtitle,
  logo,
  color,
  altLogo,
  altColor,
  onAltClick,
  onClose,
}: ChatHeaderProps): JSX.Element => {
  const intl = useIntl();

  return (
    <Row alignItems="stretch" style={{ height: 72 }}>
      {altLogo && (
        <button
          onClick={onAltClick}
          aria-label={intl.formatMessage({ id: "arialabels-switchChatTab" })}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 12px",
            border: "none",
            backgroundColor: altColor,
            cursor: "pointer",
            boxShadow: "inset -4px 0 8px rgba(0, 0, 0, 0.3)",
          }}
          data-test-id="chatHeaderAltTab"
        >
          {altLogo}
        </button>
      )}
      <Row
        flex={1}
        justifyContent="space-between"
        alignItems="center"
        padding="S300"
        backgroundColor={color}
      >
        <Row gridGap="dimensions.spacing.300" alignItems="center">
          {logo}
          <Col gridGap="S100">
            <Text fontSize="T300" fontWeight="bold" color="color.neutral.00">
              {title}
            </Text>
            {subtitle && (
              <Text fontSize="T100" color="color.neutral.00">
                {subtitle}
              </Text>
            )}
          </Col>
        </Row>
        {onClose && (
          <Button
            variant={ButtonVariant.Tertiary}
            icon={
              <IconCloseCircleFillMedium aria-hidden color="color.neutral.00" />
            }
            onClick={onClose}
            dataTestId="chatHeaderCloseBtn"
            aria-label={intl.formatMessage({
              id: "arialabels-clickToCloseChat",
            })}
          />
        )}
      </Row>
    </Row>
  );
};
